export const GET_CURRENT_ELEMENT = "GET_CURRENT_ELEMENT";
export const REFRESH_CURRENT_ELEMENT = "REFRESH_CURRENT_ELEMENT";
export const RESET_CURRENT_ELEMENT = "RESET_CURRENT_ELEMENT";
export const SET_CURRENT_ELEMENT_REQUEST_STATUS = "SET_CURRENT_ELEMENT_REQUEST_STATUS";
